import TradeAgreementGoalsConsult from './containers/TradeAgreementGoalsConsult';

export default TradeAgreementGoalsConsult;
